/**
 * Componente de paginação simples e minimalista
 * Exibe indicador de página atual e botões de navegação
 * Criado para uso em cards de KPI com listas paginadas
 */

import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./button";

interface SimplePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function SimplePagination({
  currentPage,
  totalPages,
  onPageChange,
  className = ""
}: SimplePaginationProps) {
  // Não renderiza se há apenas uma página
  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-center gap-2 pt-3 border-t border-border/50 ${className}`}>
      {/* Botão página anterior */}
      <Button
        variant="ghost"
        size="xs"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        className="h-7 w-7 p-0"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>

      {/* Indicador de página */}
      <span className="text-xs text-muted-foreground min-w-[80px] text-center">
        Página {currentPage} de {totalPages}
      </span>

      {/* Botão próxima página */}
      <Button
        variant="ghost"
        size="xs"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        className="h-7 w-7 p-0"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
